import accessPoints from './access-points';
import addressAlertNotification from './address-alert-notification';
import airlines from './airlines';
import alsat from './alsat';
import articles from './articles';
import auth from './authentication';
import autoStatusConfirmation from './auto-status-confirmation';
import branding from './branding';
import briefs from './briefs';
import categories from './categories';
import cemDataApi from './cem-data';
import cemMetaApi from './cem-meta';
import cemPipelinesApi from './cem-pipelines';
import checkIns from './checkin';
import checkinNotifications from './checkin-notifications';
import collinsonAuth from './collinson-auth';
import communicationHistory from './communication-history';
import communicator from './communicator';
import communicatorBilling from './communicator-billing';
import contact from './contact-us';
import exposures from './exposures';
import geoLocations from './geo-locations';
import geoThreatZones from './geo-threat-zones';
import incidentManagement from './incident-management';
import incidents from './incidents';
import intel from './intel';
import itinerary from './itinerary';
import organization from './organization';
import persons from './persons';
import pnr from './pnr';
import preferences from './preferences';
import ratings from './ratings';
import reports from './reports';
import resources from './resources';
import selfRegistration from './self-registration';
import servicenowIntegrationApi from './servicenow-integration';
import sites from './sites';
import supportRequests from './support-requests';
import templates from './templates';
import users from './users';
import xsrf from './xsrf';
import zendesk from './zendesk';

export default {
  accessPoints,
  articles,
  auth,
  categories,
  communicationHistory,
  contact,
  geoLocations,
  intel,
  ratings,
  organization,
  users,
  resources,
  selfRegistration,
  preferences,
  zendesk,
  reports,
  persons,
  checkIns,
  alsat,
  addressAlertNotification,
  branding,
  templates,
  geoThreatZones,
  exposures,
  checkinNotifications,
  itinerary,
  airlines,
  communicator,
  communicatorBilling,
  collinsonAuth,
  sites,
  supportRequests,
  cemDataApi,
  cemMetaApi,
  cemPipelinesApi,
  pnr,
  briefs,
  incidents,
  incidentManagement,
  autoStatusConfirmation,
  xsrf,
  servicenowIntegrationApi,
};
